import { Check } from 'lucide-react';
import { Toast, ToastProvider, ToastViewport, ToastDescription } from './toast';
import { useToast } from './use-toast';

export function Toaster() {
	const { toast } = useToast();
	return (
		<ToastProvider duration={2400} swipeDirection="down">
			{toast && (
				<Toast key={toast.id} tone={toast.tone} open={toast.open}>
					<Check className="h-3.5 w-3.5 shrink-0" />
					<ToastDescription className="text-sm font-medium opacity-100">{toast.message}</ToastDescription>
				</Toast>
			)}
			<ToastViewport />
		</ToastProvider>
	);
}
